<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
  >
    <template v-slot:header="{ ok, cancel }">
      <v-card-title class="screen-title">VN L2/L3コネクト情報</v-card-title>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click="isChanged ? ok() : cancel()"
      >
        ×
      </button>
    </template>
    <template v-if="isLoaded" v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="modifyVNL2L3Connect"
                  >変更</v-btn
                >
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="deleteVNL2L3Connect"
                  >削除</v-btn
                >
              </v-col>
            </v-row>

            <v-row>
              <!-- 基本情報 -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>基本情報</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト番号"
                        :value="wnumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト名"
                        :value="vnL2L3ConnectDetail.vnConnectName"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="回線番号"
                        :value="vnL2L3ConnectDetail.enumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VN L2/L3コネクト VLAN"
                        :value="
                          vnL2L3ConnectDetail.vnl2l3VlanIdType === 'SPECIFIED'
                            ? vnL2L3ConnectDetail.vnl2l3VnVlanId
                            : vnL2L3ConnectDetail.vnl2l3VlanIdType === 'OTHER'
                              ? 'Other'
                              : 'Untag'
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="IF状態"
                        :value="
                          $filter.enumTo(
                            vnL2L3ConnectDetail.ifStatus,
                            'cloudVn_ifStatus'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="備考"
                        :value="
                          $filter.emptyTo(vnL2L3ConnectDetail.description, '-')
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <!-- L2VN -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>L2VN</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group label="VNコード">
                        <template #value>
                          <div class="ml-3">
                            {{ vnL2L3ConnectDetail.l2VnCode }}({{
                              vnL2L3ConnectDetail.l2VnVlanIdType === "SPECIFIED"
                                ? vnL2L3ConnectDetail.l2VnVlanId
                                : vnL2L3ConnectDetail.l2VnVlanIdType === "OTHER"
                                  ? "Other"
                                  : "Untag"
                            }})
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="仮想ネットワーク(VN)名"
                        :value="vnL2L3ConnectDetail.l2VnName"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <!-- L3VPN/VN -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>L3VPN/VN</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VPN/VNコード"
                        :value="vnL2L3ConnectDetail.l3VpnVnCode"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="仮想ネットワーク(VN)名"
                        :value="
                          vnL2L3ConnectDetail.l3VpnVnCode.charAt(0) === `B`
                            ? '-'
                            : vnL2L3ConnectDetail.l3VpnVnName
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <!-- ルーティング情報 -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>ルーティング情報</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="WANアドレス"
                        :value="vnL2L3ConnectDetail.wanAddress"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ルーティング種別"
                        :value="
                          $filter.enumTo(
                            vnL2L3ConnectDetail.routingType,
                            'routingType'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col>
                <!-- NW設定 -->
                <v-row>
                  <v-col>
                    <h3>NW設定</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <div v-if="vnL2L3ConnectDetail.routingType === 'BGP4'">
                    <v-row>
                      <template
                        v-for="(item, index) in bgp4List"
                        :key="`peer${index}`"
                      >
                        <v-col cols="6">
                          <v-row>
                            <v-col>
                              <app-label-group
                                :label="`AS番号(${$filter.enumTo(item.peerName, 'peerName')})`"
                                :value="item.asNumber"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <app-label-group
                                :label="`ピアIPアドレス(${$filter.enumTo(item.peerName, 'peerName')})`"
                                :value="item.peerIpAddress"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <app-label-group
                                :label="`MD5キー(${$filter.enumTo(item.peerName, 'peerName')})`"
                                :value="$filter.emptyTo(item.md5Key, '-')"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <app-label-group
                                :label="`Maximum Prefix(${$filter.enumTo(item.peerName, 'peerName')})`"
                                :value="item.maximumPrefix"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <app-label-group
                                :label="`Local Preference(${$filter.enumTo(item.peerName, 'peerName')})`"
                                :value="
                                  $filter.enumTo(
                                    item.localPreference,
                                    'localPreference'
                                  )
                                "
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <app-label-group
                                :label="`MED(${$filter.enumTo(item.peerName, 'peerName')})`"
                                :value="$filter.enumTo(item.med, 'med')"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <app-label-group
                                :label="`経路集約(${$filter.enumTo(item.peerName, 'peerName')})`"
                                :value="
                                  $filter.enumTo(
                                    item.isRouteAggregation,
                                    'on_off'
                                  )
                                "
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </template>
                    </v-row>
                  </div>
                  <div v-else-if="vnL2L3ConnectDetail.routingType === 'STATIC'">
                    <v-row>
                      <v-col cols="12">
                        <app-label-group label="経路" />
                      </v-col>
                    </v-row>
                    <div class="ml-2">
                      <v-row>
                        <v-col cols="6">
                          <app-label-group label="LANアドレス">
                            <template #value>
                              <div class="pl-4">
                                <template v-if="sortLanAddress.length > 0">
                                  <div
                                    v-for="(lan, index) in sortLanAddress"
                                    :key="index"
                                  >
                                    {{ lan.lanAddress }}
                                  </div>
                                </template>
                                <template v-else>-</template>
                              </div>
                            </template>
                          </app-label-group>
                        </v-col>
                        <v-col cols="6">
                          <app-label-group label="ネクストホップアドレス">
                            <template #value>
                              <div class="pl-4">
                                <template v-if="sortLanAddress.length > 0">
                                  <div
                                    v-for="(lan, index) in sortLanAddress"
                                    :key="index"
                                  >
                                    {{ lan.nextHopAddress }}
                                  </div>
                                </template>
                                <template v-else>-</template>
                              </div>
                            </template>
                          </app-label-group>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                  <div v-else-if="vnL2L3ConnectDetail.routingType === 'OSPF'">
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="エリア番号"
                          :value="vnL2L3ConnectDetail.ospf!.areaNumber"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-col>
                <v-tabs
                  v-model="tabValue"
                  @update:modelValue="alertClear"
                  hide-slider
                  class="border-s-sm border-t-sm border-e-sm"
                >
                  <v-tab text="運用コマンド" value="operationCommand" />
                  <v-tab
                    text="トラフィック"
                    value="traffic"
                    v-if="!isFutureDayContract && contractSummary.isTrafficInfo"
                  />
                  <v-tab text="設定上限値" value="upperLimit" />
                </v-tabs>
                <v-tabs-window
                  v-model="tabValue"
                  class="border-s-sm border-b-sm border-e-sm"
                >
                  <v-tabs-window-item value="operationCommand">
                    <operation-command
                      ref="operationCommand"
                      lineCategory="L2L3"
                      :wnumber="wnumber"
                      :ifStatus="vnL2L3ConnectDetail.ifStatus"
                      :keyId="vnL2L3ConnectDetail.vnl2l3ConnectKeyId"
                      :routingType="vnL2L3ConnectDetail.routingType"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>
                  <v-tabs-window-item value="traffic">
                    <traffic
                      line-type="VNL2L3"
                      :line="{
                        wnumberMainAct: wnumber,
                        enumberMainAct: vnL2L3ConnectDetail.enumber,
                        l2VnCode: vnL2L3ConnectDetail.l2VnCode,
                        l3VpnVnCode: vnL2L3ConnectDetail.l3VpnVnCode,
                      }"
                    />
                  </v-tabs-window-item>
                  <v-tabs-window-item value="upperLimit">
                    <upper-limit
                      upperLimitManageUnit="VNL2L3"
                      :enumber="vnL2L3ConnectDetail.enumber"
                    />
                  </v-tabs-window-item>
                </v-tabs-window>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="isChanged ? ok() : cancel()"
              variant="outlined"
              color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { mapState } from "vuex";
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { ContractInfo } from "@/apis/ContractApi";
import type { Bgp4Peer, VNL2L3ConnectDetail } from "@/apis/VNL2L3ConnectApi";
import VNL2L3ConnectEdit from "@/modals/vnL2L3Connect/VNL2L3ConnectEdit.vue";
import VNL2L3ConnectDelete from "@/modals/vnL2L3Connect/VNL2L3ConnectDelete.vue";
import Traffic from "@/components/operation-tool/Traffic.vue";
import OperationCommand from "@/components/operation-tool/OperationCommand.vue";
import UpperLimit from "@/components/operation-tool/UpperLimit.vue";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "VNL2L3ConnectReference",
  components: { OperationCommand, Traffic, UpperLimit },
  props: {
    wnumber: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "operationCommand" as
        | "operationCommand"
        | "traffic"
        | "upperLimit",
      isLoaded: false,
      isChanged: false,
      vnL2L3ConnectDetail: {} as VNL2L3ConnectDetail,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
      contractSummary: "contractSummary",
    }),
    /** bgp4のリスト（peer1、peer2の順で返却） */
    bgp4List(): Bgp4Peer[] {
      return this.vnL2L3ConnectDetail.bgp4!.sortBy(["peerName", "asc"]);
    },
    /** LANアドレス・ネクストホップアドレスのペアをLANアドレス順で昇順ソート */
    sortLanAddress(): { lanAddress: string; nextHopAddress: string }[] {
      if (!this.vnL2L3ConnectDetail.static) return [];
      const list = this.vnL2L3ConnectDetail.static;
      return [...list].sort((a, b) =>
        sortCompare(a, b, [["lanAddress", "asc"]])
      );
    },
    /** 開始日が未来日の場合,true*/
    isFutureDayContract(): boolean {
      return !this.contractInfo.contractList.find(
        (e: ContractInfo["contractList"][0]) =>
          e.enumber === this.vnL2L3ConnectDetail.enumber
      );
    },
  },
  methods: {
    async load() {
      this.vnL2L3ConnectDetail =
        await this.$api.vNL2L3Connect.getVNL2L3ConnectDetail(this.wnumber);
    },

    /** 削除*/
    async deleteVNL2L3Connect() {
      await this.alertClear();
      await this.$modal.show(VNL2L3ConnectDelete, {
        vnL2L3ConnectDetail: this.vnL2L3ConnectDetail,
      });
      await this.$api.vNL2L3Connect.deleteVNL2L3Connect(this.wnumber, {
        vnl2l3ConnectKeyId: this.vnL2L3ConnectDetail.vnl2l3ConnectKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** 変更*/
    async modifyVNL2L3Connect() {
      await this.alertClear();
      await this.$modal.show(VNL2L3ConnectEdit, {
        wnumber: this.wnumber,
        vnL2L3ConnectDetail: this.vnL2L3ConnectDetail,
      });
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },

    /**
     * コマンド実行後の処理
     * IF設定反映の場合、一覧画面へ戻る
     * @param eventType 実行されたコマンドの種類
     */
    async executed(eventType: string) {
      if (eventType === "IF_STATE") {
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      } else {
        this.isChanged = true;
        await this.load();
      }
    },

    /** エラーメッセージを初期化する */
    async alertClear() {
      await (
        this.$refs.operationCommand as InstanceType<typeof OperationCommand>
      ).alertClear();
    },
  },
});
</script>
